import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"

export const KeyCaptionPercentage = ({ number, text, percentage }: { number: number | string; text: string; percentage?: number }) => {
    const existPercentage = !!percentage || percentage == 0
    const styles = useStyles()
    return (
        <Box sx={styles.display}>
            <Typography sx={styles.text({ percentageExisted: existPercentage })}>{text}</Typography>
            <Box sx={styles.container}>
                <Typography sx={styles.number({ percentageExisted: existPercentage })}>{number}</Typography>
                {existPercentage && <Typography sx={styles.percentage}>{percentage}%</Typography>}
            </Box>
        </Box>
    )
}